import React from 'react';
import {FormattedMessage} from 'react-intl';
import {string, bool, func, object} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {basicForm} from 'utils/helpers';
import config from './changeEmailFormConfig';

const ChangeEmailForm = basicForm(config);

const ChangeEmailModal = props => (
  <BasicModal
    header={ "Change Email for " +  props.email }
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    dimmer='inverted'
    modalSize='small'
    actions={[
      {
        label: "Cancel",
        action: props.handleClose,
        isDisabled: props.changingEmail,
        displayType: 'menu-item'
      },
      {
        label: "Change Email",
        action: props.submit,
        loading: props.changingEmail,
        isDisabled: props.hasErrors || false,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <ChangeEmailForm
      email={props.email}
      newEmail={props.email}
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
  </BasicModal>
);

ChangeEmailModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,
  handleClose: func.isRequired,
  email: string,
  modalOpen: bool.isRequired,
  changingEmail: bool
};

export default ChangeEmailModal;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ChangeEmailModal/ChangeEmailModal.jsx